import React from "react";
import TimeSheetPage from "./timesheet-index/TimeSheetPage";
import { UserRole } from "src/app/@types/enums/user.roles";

export const AdminTimeSheetRoutes = {
  settings: {
    layout: {},
  },
  auth: [UserRole.Admin],
  routes: [
    {
      path: "admin/timesheet",
      element: <TimeSheetPage />,
    },
  ],
};
